import React from 'react';
import { styled } from "../../../stitches.config"
import SlateRenderer from "./Slate/SlateRenderer";

import { withThemeContext } from '../../../redesign/components/StitchesThemeProvider';

const LiveItem = ({ settings, article, hideAdslots, isDarkMode }) => {
    const { parts, date } = settings;
    const isImportant = settings.important === "1"
    const icon = settings.icon ?? null;
    const show_date = settings.show_date ?? true;
    const football_crest = settings.football_crest ?? 0;
    const icon_text = settings.icon_text ?? null;
    const icon_flag_url = settings.icon_flag_url ?? null;
    const backgroundColor = "#" + settings.background_color ?? '#fff';

    return (
        <>
            {
                football_crest ?
                    null
                    :
                    <Container>
                        <Wrapper showDate={show_date} >
                            <Date>
                                {show_date && date}
                            </Date>
                            <Content css={{ "$$background": backgroundColor }} className={settings.background_color ? "live-item-content-with-padding" : "live-item-content"}>
                                <div className={isImportant ? "important-style-wrapper" : ""}>
                                    <SlateRenderer parts={parts} hideAdslots={hideAdslots} />
                                </div>
                                {icon &&
                                    <Icon>
                                        <img src={icon} className={isDarkMode ? "live-icon--dark-mode" : ""} />
                                        {icon_text && <p>{icon_text}</p>}
                                        {icon_flag_url && <img className="live-item-flag" src={icon_flag_url} />}
                                    </Icon>
                                }
                            </Content>
                        </Wrapper>
                    </Container>
            }
        </>
    );
}

const Icon = styled('div', {
    maxWidth: "fit-content",
    display: "flex",
    alignItems: "center",
    "& img": {
        width: "24px",
        height: "24px",
    },
    "& p": {
        color: "$grayscale100",
        fontFamily: "$grotesk",
        margin: "0 8px 0 8px",
        fontWeight: 800,
        fontSize: "16px",
    },
    "& .live-item-flag": {
        width: "18px",
        height: "18px",
        borderRadius: "18px",
        marginLeft: "24px",
        "@bp4": {
            width: "24px",
            height: "24px",
            borderRadius: "24px",
            marginLeft: "40px",
        }
    }
})

const Container = styled('div', {
    borderLeft: "2px solid #E7E7E7",
    padding: "0px 4px 32px 16px",
    margin: 0,
    position: "relative",

    "@bp4": {
        padding: "0px 20px 54px 47px",
    },

    "&:before": {
        content: " ",
        display: "block",
        position: "absolute",
        left: "-7px",
        width: "12px",
        top: "-7px",
        height: "12px",
        borderRadius: "12px",
        background: "#8D8D8D",
        border: "3px solid #f5f5f5",
    },
})


const Content = styled('div', {
    backgroundColor: "$$background",
    "& .live-icon--dark-mode": {
        padding: "2px",
        borderRadius: "24px",
        background: "$grayscale0Fixed !important",
    },

    "& .html": {
        "& iframe": {
            margin: "0 auto 12px auto !important",
        }
    }
})

const Wrapper = styled('div', {
    top: "-14px",
    position: "relative",
    margin: "0px !important",

    "& h3": {
        marginTop: "5px",
    },

    "& p": {
        fontFamily: "Charis SIL",
        fontSize: "21px",
        fontWeight: "400",
        lineHeight: "32px",
        color: "$grayscale100",
        display: "inline",
    },

    "& .important-style-wrapper": {
        "& p": {
            fontFamily: "HK Grotesk",
            fontSize: "24px",
            fontWeight: "700",
            lineHeight: "30px",
            color: "white",
            background: "black",
            paddingLeft: "2px",
        }
    },

    "& div": {
        margin: "8px 0 0 0",
    },

    "& .live-item-content-with-padding": {
        padding: "4px 8px",
    }
})

const Date = styled('div', {
    position: "relative",
    color: "$primary",
    fontFamily: "HK Grotesk",
    fontSize: "16px",
    fontWeight: "800",
    lineHeight: "28px",
    letterSpacing: "0px",
    textAlign: "left",
    margin: "0 !important",
})

export default withThemeContext(LiveItem);